import React from "react";

// Components
import Seo from "../../components/Seo";
import Header from "../../components/Header.js";
import Footer from "../../components/Footer.js";
import LearningVideosContent from "../../components/LearningVideosContent.js";

const LearningVideos = () => {
  return (
    <div>
      <Seo
        title="Sustainability Learning Videos"
        description="Watch the ISA learning videos on sustainability and ESG and gain insights into what we can do for future generations, with more on our YouTube channel."
        path="/learning-videos"
        breadcrumbs={[{ name: "Learning Videos", path: "/learning-videos" }]}
      />
      <Header />
      <div id="videos" style={{ paddingTop: "130px" }}>
        <LearningVideosContent titleAs="h1" />
      </div>
      <Footer />
    </div>
  );
};

export default LearningVideos;
